// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-vue label {\n  text-align: left;\n  display: block;\n  color: #586174;\n  margin-bottom: 5px;\n  font-size: 13px;\n  font-weight: 500;\n}\n", ""]);
// Exports
module.exports = exports;
